/**
 * Reveal-on-scroll — progressive enhancement.
 *
 * Elements marked [data-reveal] fade + rise into place the first time they
 * cross into the viewport. Grid items can carry `--reveal-i` for a staggered
 * cascade (see critical.css).
 *
 * Fails safe: the hidden-state gate (`reveal-on` on <html>) is only added once
 * this script runs and motion is allowed. So if JS is off, this script errors,
 * or the visitor prefers reduced motion, nothing is ever hidden — all content
 * shows normally with no animation.
 */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if ((mq && mq.matches) || !('IntersectionObserver' in window)) return;

  var root = document.documentElement;
  // Add the gate first so tagged elements are hidden before the browser paints
  // below-the-fold content — no flash of visible-then-hidden.
  root.classList.add('reveal-on');

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-revealed');
        io.unobserve(entries[i].target); // reveal once, then stop watching
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observe(scope) {
    (scope || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      io.observe(el);
    });
  }

  // Reveal anything already in the viewport on load *instantly* (no fade), so it
  // paints at full opacity. This avoids animating an above-the-fold LCP element
  // — a fade from opacity:0 would delay LCP. Only content scrolled to animates.
  function init() {
    var vh = window.innerHeight || root.clientHeight;
    var nodes = document.querySelectorAll('[data-reveal]');
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) nodes[i].classList.add('is-revealed');
    }
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: reveal freshly-rendered sections too.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  // Content injected at runtime (e.g. AJAX product recommendations) fires this
  // so its [data-reveal] nodes get observed — otherwise they'd stay hidden.
  document.addEventListener('reveal:scan', function () { observe(); });
})();
